import Username from "@sentrei/common/models/Username";

// eslint-disable-next-line import/prefer-default-export
export const username: Username = {
  uid: "userId",
};
